<template>
    <div class="types-of-cargo">
        <h2 class="section-title">Какие грузы перевозит ПЭК</h2>
        <div class="types-of-cargo-wrapper">
            <div class="types-of-cargo__list">
                <div class="types-of-cargo__item">
                    <img class="types-of-cargo__item-img"
                            src="@/assets/images/map_furniture-store.svg"
                            alt="Иконка мебель"/>
                    <p class="types-of-cargo__item-text">Мебель</p>
                </div>
                <div class="types-of-cargo__item">
                    <img class="types-of-cargo__item-img"
                            src="@/assets/images/car.svg"
                            alt="Иконка авто"/>
                    <p class="types-of-cargo__item-text">Автомобильная техника</p>
                </div>
                <div class="types-of-cargo__item">
                    <img class="types-of-cargo__item-img"
                            src="@/assets/images/setting-2.svg"
                            alt="Иконка запчасти"/>
                    <p class="types-of-cargo__item-text">Оборудование</p>
                </div>
                <div class="types-of-cargo__item">
                    <img class="types-of-cargo__item-img"
                            src="@/assets/images/hospital.svg"
                            alt="Иконка медицина"/>
                    <p class="types-of-cargo__item-text">Мед.техника</p>
                </div>
                <div class="types-of-cargo__item">
                    <img class="types-of-cargo__item-img"
                            src="@/assets/images/cpu.svg"
                            alt="Иконка микросхема"/>
                    <p class="types-of-cargo__item-text">Компьютерная техника</p>
                </div>
                <div class="types-of-cargo__item">
                    <img class="types-of-cargo__item-img"
                            src="@/assets/images/solar_cosmetic-bold.svg"
                            alt="Иконка косметика"/>
                    <p class="types-of-cargo__item-text">Косметика</p>
                </div>
                <div class="types-of-cargo__item">
                    <img class="types-of-cargo__item-img"
                            src="@/assets/images/document-text.svg"
                            alt="Иконка документ"/>
                    <p class="types-of-cargo__item-text">Бумажная продукция</p>
                </div>
                <div class="types-of-cargo__item">
                    <img class="types-of-cargo__item-img"
                            src="@/assets/images/ph_buildings-fill.svg"
                            alt="Иконка дома"/>
                    <p class="types-of-cargo__item-text">Строительные материалы и т.д.</p>
                </div>
            </div>
            <div class="types-of-cargo__column">
                <div class="types-of-cargo__commercial">
                    <h3 class="subsection-title">Коммерческие грузы</h3>
                    <div class="types-of-cargo__commercial-list">
                        <div class="types-of-cargo__commercial-list-item">
                            <img class="types-of-cargo__commercial-list-item-img"
                                    src="@/assets/images/maximize-3.svg"
                                    alt="Иконка размер"/>
                            <p class="types-of-cargo__commercial-list-item-text">
                                Косметика для сетевого магазина
                            </p>
                        </div>
                        <div class="types-of-cargo__commercial-list-item">
                            <img class="types-of-cargo__commercial-list-item-img"
                                    src="@/assets/images/solar_washing-machine-linear.svg"
                                    alt="Иконка бытовая техника"/>
                            <p class="types-of-cargo__commercial-list-item-text">
                                Стиральные машины в гипермаркет
                            </p>
                        </div>
                        <div class="types-of-cargo__commercial-list-item">
                            <img class="types-of-cargo__commercial-list-item-img"
                                    src="@/assets/images/iconoir_fishing.svg"
                                    alt="Иконка рыболовный крючок"/>
                            <p class="types-of-cargo__commercial-list-item-text">
                                Различные подводные аксессуары в магазин спорт. товаров
                            </p>
                        </div>
                    </div>
                </div>
                <div class="types-of-cargo__personal">
                    <h3 class="subsection-title">Перевозка личных вещей</h3>
                    <div class="types-of-cargo__personal-list">
                        <div class="types-of-cargo__personal-list-item">
                            <img class="types-of-cargo__personal-list-item-img"
                                    src="@/assets/images/solar_t-shirt-line-duotone.svg"
                                    alt="Иконка одежда"/>
                            <p class="types-of-cargo__personal-list-item-text">
                                Одежда
                            </p>
                        </div>
                        <div class="types-of-cargo__personal-list-item">
                            <img class="types-of-cargo__personal-list-item-img"
                                    src="@/assets/images/milk.svg"
                                    alt="Иконка бутылка"/>
                            <p class="types-of-cargo__personal-list-item-text">
                                Посуда
                            </p>
                        </div>
                        <div class="types-of-cargo__personal-list-item">
                            <img class="types-of-cargo__personal-list-item-img"
                                    src="@/assets/images/scissor.svg"
                                    alt="Иконка ножницы"/>
                            <p class="types-of-cargo__personal-list-item-text">
                                Канцелярские товары
                            </p>
                        </div>
                        <div class="types-of-cargo__personal-list-item">
                            <img class="types-of-cargo__personal-list-item-img"
                                    src="@/assets/images/setting-2-white.svg"
                                    alt="Шестеренка"/>
                            <p class="types-of-cargo__personal-list-item-text">
                                Инструменты
                            </p>
                        </div>
                    </div>
                </div>
                <div class="types-of-cargo__warning">
                    <h3 class="subsection-title">Опасные, хрупкие и ценные грузы</h3>
                    <p class="types-of-cargo__warning-description">
                        <strong>Особые условия:</strong> Мы не принимаем к перевозке опасные грузы (с любым классом опасности)
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
.types-of-cargo {
    margin-top: 80px;
    margin-bottom: 60px;
    display: flex;
    flex-direction: column;
    gap: 40px;
}
.types-of-cargo-wrapper {
    display: flex;
    gap: 24px;
}
.types-of-cargo__list {
    flex: 0 0 calc(50%-12px);
    padding: 32px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    background-color: #F5F5F5;
    border-radius: 20px;
}
.types-of-cargo__item {
    padding: 18.5px 16px;
    background-color: #FFFFFF;
    display: flex;
    align-items: center;
    gap: 12px;
    border-radius: 16px;
}
.types-of-cargo__item-img {
    padding: 6px;
    background-color: #48538B1A;
    border-radius: 8px;
}
.types-of-cargo__item-text {
    font-weight: 500;
    font-style: Medium;
    font-size: 18px;
    leading-trim: NONE;
    line-height: 26px;
    letter-spacing: 0%;
    vertical-align: middle;
    margin: 0;
}
.types-of-cargo__column {
    flex: 0 0 50%;
    display: flex;
    flex-direction: column;
    gap: 24px;
}
.types-of-cargo__commercial {
    padding: 32px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    background-color: #F5F5F5;
    border-radius: 20px;
}
.types-of-cargo__commercial-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
}
.types-of-cargo__commercial-list-item {
    padding: 12px 16px;
    display: flex;
    gap: 8px;
    align-items: center;
    background-color: #FFFFFF;
    border-radius: 20px;
    width: fit-content;
}
.types-of-cargo__commercial-list-item-text {
    font-weight: 500;
    font-style: Medium;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 22px;
    letter-spacing: 0%;
    vertical-align: middle;
    margin: 0;
}
.types-of-cargo__personal {
    padding: 32px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    background-color: #F5F5F5;
    border-radius: 20px;
}
.types-of-cargo__personal-list {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
}
.types-of-cargo__personal-list-item {
    padding: 12px 16px;
    display: flex;
    gap: 8px;
    align-items: center;
    background-color: #FFFFFF;
    border-radius: 20px;
    width: fit-content;
}

.types-of-cargo__personal-list-item-text {
    font-weight: 500;
    font-style: Medium;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 22px;
    letter-spacing: 0%;
    vertical-align: middle;
    margin: 0;
}
.types-of-cargo__warning {
    padding: 32px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    background-color: #F5F5F5;
    border: 1px solid #F9B53F;
    border-radius: 20px;
}
.types-of-cargo__warning-description {
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 24px;
    letter-spacing: 0%;
    margin: 0;
}
.subsection-title {
    font-weight: 500;
    font-style: Medium;
    font-size: 20px;
    leading-trim: NONE;
    line-height: 28px;
    letter-spacing: 0%;
    vertical-align: middle;
    margin: 0;
}
@media screen and (max-width: 1279px) {
    .types-of-cargo-wrapper {
        flex-direction: column;
    }
    .types-of-cargo {
        flex-direction: column;
    }
    .types-of-cargo__list {
        padding: 24px;
    }
    .types-of-cargo__commercial {
        padding: 24px;
    }
    .types-of-cargo__personal {
        padding: 24px;
    }
    .types-of-cargo__item {
        padding: 16px;
    }
    .types-of-cargo__commercial-list-item {
        padding: 16px;
    }
    .types-of-cargo__personal-list-item {
        padding: 16px;
    }
}
@media screen and (max-width: 768px) {
    .types-of-cargo__item-text {
        font-size: 16px;
        line-height: 26px;
    }
    .subsection-title {
        font-size: 18px;
        line-height: 26px;
    }
    .types-of-cargo__warning-description {
        font-size: 16px;
        line-height: 24px;
    }
}
@media screen and (max-width: 768px) {
    .types-of-cargo {
        margin-top: 40px;
    }
}
</style>